import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  verificationWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native form controls / scrollbars follow the active theme.
    colorScheme: theme.palette.type,
    padding: '50px',
    minHeight: '100vh',
    // `secondary.silver` is only declared in the DARK palette, so in light these
    // declarations were dropped and the headings simply inherited. Left out
    // entirely now: keeping them would have rendered these headings in a dark
    // SURFACE colour once this page became themeable, i.e. invisible.
    '& h3': {
      fontWeight: '400',
      marginTop: '60px',
    },
    '& h5': {
      fontWeight: '400',
    },
    '& img': {
      display: 'block',
      margin: 'auto',
    },
    '& .MuiTextField-root': {
      marginBottom: '10px',
    },
  },
  verification: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '280px',
  },
  // Dead: the terms <Checkbox> in index.js uses `color="primary"` and carries no
  // className. Pointed at the text token anyway so re-wiring it does not
  // resurrect the original white-on-white.
  checkbox: {
    color: theme.palette.text.primary,
    '& .MuiIconButton-root': {
      color: theme.palette.text.primary,
    },
    '& span': {
      fontSize: '13px',
      fontWeight: '100',
    },
  },
  image: {
    maxWidth: '280px',
    maxHeight: '100%',
  },
  buttonsPDFViewer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
}));

export default useStyles;
